module.exports = __webpack_public_path__ + "dea65ede5744c26daf5209cf9da9e7bd.png";